import LoadingOverlayContent from "../Shape/ShapeFullScreenOverlay/LoadingOverlayContent";
import ShapeFullScreenOverlay from "../Shape/ShapeFullScreenOverlay/ShapeFullScreenOverlay";
import { theming } from "../Shape/theming";

interface Props {
  loading: boolean;
  theme: keyof typeof theming;
  noAnimation?: boolean;
}

export default function LoadingScreen({ loading, theme, noAnimation }: Props) {
  return (
    <ShapeFullScreenOverlay
      open={loading}
      measurements={{ height: 0, width: 0, left: 0, top: 0 }}
      theme={theming[theme]}
      noAnimation={noAnimation}
      fullScreenOverlay={(props) => (
        <LoadingOverlayContent
          {...props}
          loading={loading ? "loading" : "ready"}
        />
      )}
    />
  );
}
